module.exports = __webpack_public_path__ + "img/play-btn.4475eca.svg";